import React from 'react'
import { graphql } from 'gatsby'
import style from './features.mod.scss'
import Img from 'gatsby-image'

const Features = ({ image, featureList }) => {
  return (
    <div className={style.features}>
      <div className={style.features__wrap}>
        <div className={style.features__grid}>
          <div className={style.features__image}>
            <Img fluid={image.fluid} />
          </div>
          {featureList.map(item => (
            <div className={style.features__feature} key={`feature-${item.id}`}>
              <div className={style.features__icon}>
                <Img fluid={item.icon.fluid} />
              </div>
              <div>
                <h4>{item.title}</h4>
                <p>{item.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Features

export const query = graphql`
  fragment FeatureContent on DatoCmsFeatureContent {
    id
    heading
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    model {
      apiKey
    }
    background
    backgroundStyle
    padding
    image {
      fluid(maxWidth: 500, imgixParams: { fit: "crop", w: "500" }) {
        ...GatsbyDatoCmsFluid
      }
    }
    featureList {
      id
      caption
      title
      icon {
        fluid(maxWidth: 120, imgixParams: { fit: "crop", w: "120" }) {
          ...GatsbyDatoCmsFluid
        }
      }
    }
  }
`
